import styled from '@emotion/styled';

export const ProductStepContent = styled.div``;
